import { components } from "../lib/api/v1";

export type PaidServiceName = "learning_management" | "ai_question";

export type PaidService = components["schemas"]["PaidService"];

export const toJapanese = (name: PaidServiceName): string => {
  switch (name) {
    case "learning_management":
      return "学習管理";
    case "ai_question":
      return "AI質問";
  }
};

export const hasLearningManagementService = (entity: {
  paidServices?: PaidService[];
}): boolean => {
  return (
    entity.paidServices?.some((s) => s.name === "learning_management") ?? false
  );
};
